import styled, {css} from "styled-components"

import {H4} from "@irati/ui/src//Typography/Heading"
import {Label1, Label2} from "@irati/ui/src/Labels"
import {WorkSansBold} from "@irati/ui/src/global/fonts"
import {greys} from "@irati/ui/src/global/colors"

export const BalanceWrapper = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.four} 0 ${theme.spacing.two};
    border-bottom: 1px solid ${theme.colors.primary2_50};
  `}
`
interface HeaderWrapperProps {
  selected?: boolean
}

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  justify-content: center;
  ${({theme, selected}) => selected && `background-color: ${theme.colors.utility.highlight};`}
  padding-left: 20px;
  border-radius: 4px;

  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.tablet`
      justify-content: flex-start;
    `}
  `}
`

export const RadioGroupWrapper = styled.div`
  height: 60%;
`

export const StyledLabel1 = styled(Label1)`
  font-size: 14px;
  line-height: 20px;
`

export const StyledLabel2 = styled(Label2)`
  display: block;
  margin-top: 5px;
  color: ${greys.mediumDark};
`

export const StyledH4 = styled(H4)`
  font-size: 21px;
  line-height: 23px;
`

export const BoldMessage = styled.span`
  ${WorkSansBold}
`

export const ZipImage = styled.img`
  margin: 8px 16px 8px 0;
  height: 35px;
`

export const ZipDetail = styled.img`
  margin-right: 8px;
`

export const CreditCardImage = styled.img`
  display: block;
  margin-left: 10px;
  margin-right: auto;
`

export const PaymentsH2 = styled.p`
  font-family: ${({theme}) => theme.font.semibold};
  color: ${({theme}) => theme.colors.utility.ink};
  font-size: 16px;
  letter-spacing: 0.3px;
  word-break: break-all;
`

export const PaymentCheckbox = styled.div`
  position: initial;
`
